import { mapGetters } from 'vuex'
import AccountIcon from '@/components/base/AccountIcon'
export default {
  components: { AccountIcon },
    computed: {
      ...mapGetters({
        currentUser: 'Users/currentUser',
        isInternal: 'Permissions/isInternal',
        currentSelectedOrg: 'Permissions/currentSelectedOrg',
      }),
      userName () {
        return `${(this.currentUser.firstName || '')} ${(this.currentUser.lastName || '')}`
      },
      orgIsSelected () {
        return !!this.currentSelectedOrg.id
      },
      userRoleOnOrg () {
        if (this.orgIsSelected) {
          if (this.isInternal) return 'Internal'
          else {
            const userOrg = this.currentUser.orgs.find(org => org.id === this.currentSelectedOrg.id)
            return userOrg.role
          }
        }
        return undefined
      },
    },
    methods: {
      goToAccountSettings () {
        this.$router.push({ name: 'Account Settings' })
      },
      logout () {
        this.$store.dispatch('logout')
      },
    },
}
